module.exports = __webpack_public_path__ + "img/8_46.a4d29f9c.png";